export const MenuList = [
  //Dashboard
  {
    title: 'Dashboard',
    classsChange: 'mm-collapse',
    iconStyle: <i className="fas fa-home" />,
    content: [
      {
        title: 'Dashboard',
        to: 'dashboard',
      },
      {
        title: 'Tour Bookings',
        to: 'tour-booking',
      },
      {
        title: 'Hotel Bookings',
        to: 'hotel-booking',
      },
      {
        title: 'Flight Bookings',
        to: 'flight-booking',
      },
      {
        title: 'Admission Enquiries',
        to: 'admission-enquiries',
      },
      {
        title: 'Services',
        to: 'package-list',
      },
      {
        title: 'Vendors',
        to: 'vendors',
      },

      {
        title: 'Queries',
        to: 'queries',
      },
      {
        title: 'Complaints',
        to: 'complaints',
      },
      {
        title: 'Contact Us',
        to: 'contacts',
      },
      {
        title: 'Attendance',
        to: 'attendance',
      },
      {
        title: 'Leaves',
        to: 'leaves',
      },
    ],
  },
];
